export default "__VITE_ASSET__4dc53f24__"